import { render, staticRenderFns } from "./scoreSeg.vue?vue&type=template&id=6cd19d03&scoped=true"
import script from "./scoreSeg.vue?vue&type=script&lang=js"
export * from "./scoreSeg.vue?vue&type=script&lang=js"
import style0 from "./scoreSeg.vue?vue&type=style&index=0&id=6cd19d03&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd19d03",
  null
  
)

export default component.exports